import React, {useEffect, useState} from 'react';
import {useAppBridge} from '@shopify/app-bridge-react';

// ui-components
import SelfMailerPlain from '~/pages/plain/SelfMailer';

// types
import {Intent, PlainObject} from '~/types/shopify.types';

const SelfMailer: React.FC<React.PropsWithoutRef<any>> = () => {
  const shopify = useAppBridge();
  const [intent, setIntent] = useState<Intent | PlainObject>({});

  useEffect(() => {
    const cleanup = shopify.intents.register(setIntent);

    return () => cleanup();
  }, [shopify.intents]);

  return (
    <SelfMailerPlain
      intent={(intent as Intent)}
      onComplete={fields => intent.finish(fields)}/>
  );
};

export default SelfMailer;
